import { observer } from 'mobx-react-lite'
import { usePollDesignReplacement } from './usePollDesignReplacement'
import { useRootStore } from 'stores/RootStore'

interface Props {
  designKey: string
  scheduledPostId?: number
  onComplete?: () => void
}

export const PollDesignReplacement = observer(({ designKey, scheduledPostId, onComplete }: Props) => {
  const { generationTimestampStore } = useRootStore()
  const replaceFrameBatchId = generationTimestampStore.getReplaceFrameBatchId(designKey)

  usePollDesignReplacement({
    replaceFrameBatchId,
    designKey,
    scheduledPostId,
    onComplete: () => {
      generationTimestampStore.completeGeneration(designKey)

      onComplete?.()
    },
  })

  return null
})
